import { InputHTMLAttributes, useState, ChangeEvent } from 'react';
import BEM from '../../../../common/bem';

const classes = BEM.with('file-upload');

type Props = {
  id: string;
  label?: string;
  onFilesSelect?: (event: ChangeEvent<HTMLInputElement>) => void;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange' | 'id'>;

const CustomFileInput = ({
  id,
  label = 'Upload file',
  onFilesSelect,
  multiple,
  ...inputProps
}: Props) => {
  const [status, setStatus] = useState('No file selected');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    if (!files || files.length === 0) {
      setStatus('No file selected');
      onFilesSelect?.(e);
      return;
    }
    const fileArray = Array.from(files);

    if (multiple) {
      setStatus(`${fileArray.length} files selected`);
    } else {
      setStatus(fileArray[0].name);
    }
    onFilesSelect?.(e);
  };
  return (
    <div className={classes()}>
      <label htmlFor={id} className="file-label">
        {label}
      </label>

      <label htmlFor={id} className="file-button">
        {multiple ? 'Choose files' : 'Choose file'}
      </label>

      <input
        id={id}
        type="file"
        className="file-input"
        multiple={multiple}
        onChange={handleChange}
        aria-describedby={`${id}-status`}
        {...inputProps}
      />

      <span id={`${id}-status`} className="file-status">
        {status}
      </span>
    </div>
  );
};

export default CustomFileInput;
